import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Icon } from '../../../icon/icon';
import { AddOnData } from '../add-ons';
import { Card } from './card';
import { GcpAdjustmentContent } from './gcp-adjustment-content';

type Props = {
  onChange: (data: AddOnData) => void;
  gcpPoints: boolean;
  selected: boolean;
  comment?: string;
  selfReview?: boolean;
};

const GcpAdjustmentCard = (props: Props) => {
  const { t } = useTranslation('cloudProcessing');
  const [selected, setSelected] = React.useState(props.selected);
  const [expanded, setExpanded] = React.useState(false);

  // Sync internal state with props when props change
  React.useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const onToggle = () => {
    if (props.gcpPoints) {
      const newSelected = !selected;
      setSelected(newSelected);
      if (newSelected) {
        setExpanded(true);
      }
      props.onChange({ gcpAdjustment: { enabled: newSelected } });
    }
  };

  const isDisabled = props.gcpPoints === false;

  const aiBadge = (
    <AiBadge>
      <Icon fixedWidth={true} icon="sparkles" />
      {t('setupDialog.addOns.gcpAdjustment.aiBadge', { ns: 'cloudProcessing' })}
    </AiBadge>
  );

  return (
    <Card
      disabled={isDisabled}
      expanded={expanded}
      selected={selected}
      title={
        props.gcpPoints
          ? t('setupDialog.addOns.gcpAdjustment.cardTitle', { ns: 'cloudProcessing' })
          : t('setupDialog.addOns.gcpAdjustment.cardTitleMissing', { ns: 'cloudProcessing' })
      }
      titleBadge={aiBadge}
      onClick={onToggle}
      onExpandedChange={setExpanded}
    >
      <GcpAdjustmentContent
        comment={props.comment}
        selected={selected}
        selfReview={props.selfReview ?? false}
        onChange={props.onChange}
      />
    </Card>
  );
};

const AiBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  padding: 0.2em 0.6em;
  border-radius: 999px;
  background: linear-gradient(135deg, #7c3aed, #a855f7);
  color: #fff;
  font-size: 10pt;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 4px rgba(124, 58, 237, 0.4);
  white-space: nowrap;
`;

export { GcpAdjustmentCard };
